import React from "react"
import { Link, graphql } from "gatsby"

import listStyle from '../style/list-style.module.scss';

import Layout from "../components/layout"
import SEO from "../components/seo"
import Category from '../components/category/category';

const CategoryPageTemplate = ({ data, pageContext, location }) => {
  console.log(data);
  const posts = data.allMarkdownRemark.edges || [];
  const siteTitle = data.site.siteMetadata.title
  const { availableCategories, category } = pageContext
  const breadcrumbs = [{ name: 'Головна', slug: '/' }, { name: category.name, slug: null }]
  console.log(posts);
  return (
    <Layout availableCategories={availableCategories} breadcrumbs={breadcrumbs} location={location} title={siteTitle}>
      <SEO
        lang="uk"
        title={category.name}
        description={category.description}
      />
      <div className={listStyle.container}>
        {posts.map(({ node }) => {
          const data = node.frontmatter;
          return (
            <article className={listStyle.article} key={node.fields.slug}>
              <div
                style={{
                  backgroundImage: `url(${data.image.childImageSharp.fluid.src})`
                }}
                className={listStyle.article__photo}>
                <div className={listStyle.article__photo_overlay}></div>
              </div>
              <div className={listStyle.article__categories}>
                <Category categories={data.categories} />
              </div>
              <Link className={listStyle.article__title} to={node.fields.slug}>
                {data.title}
              </Link>
              <section>
                <p>{data.teaser}</p>
              </section>
              <div className={listStyle.article__actions}>
                <Link className={listStyle.article__actions_button} to={node.fields.slug}>
                  Читати
                </Link>
              </div>
            </article>
          )
        })}
      </div>
    </Layout>
  )

}

export default CategoryPageTemplate;

export const pageQuery = graphql`
query PostsByCategory($categoryValue: String!) {
    site {
        siteMetadata {
          title
        }
      }
    allMarkdownRemark(sort: {fields: frontmatter___date}, filter: {frontmatter: {categories: {elemMatch: {value: {eq: $categoryValue}}}}}) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date
            description
            title
            teaser
            categories {
              name
              isDog
              isCat
              value
              priority
              description
            }
            image {
              childImageSharp {
                fluid {
                  src
                }
              }
            }
          }
          excerpt(pruneLength: 100)
          html
          id
        }
      }
    }
  }
`
